import NutritionalHistory from './NutritionalHistory';

export default NutritionalHistory;
